import { CDN_URL } from './index'

export default [
  // {
  //   num: 12,
  //   icon: `${CDN_URL}/offlinePay/goods/lingfu.png?v=1`,
  //   price: 1,
  //   name: '测试专用',
  //   id: 1
  // },
  {
    num: 12,
    icon: `${CDN_URL}/offlinePay/goods/lingfu.png?v=1`,
    price: 12,
    name: '12灵符',
    id: 12
  },
  {
    num: 30,
    icon: `${CDN_URL}/offlinePay/goods/lingfu.png?v=1`,
    price: 30,
    name: '30灵符',
    id: 30
  },
  {
    num: 68,
    icon: `${CDN_URL}/offlinePay/goods/lingfu.png?v=1`,
    price: 68,
    name: '68灵符',
    id: 68
  },
  {
    num: 98,
    icon: `${CDN_URL}/offlinePay/goods/lingfu.png?v=1`,
    price: 98,
    name: '98灵符',
    id: 98
  },
  {
    num: 198,
    icon: `${CDN_URL}/offlinePay/goods/lingfu.png?v=1`,
    price: 198,
    name: '198灵符',
    id: 198
  },
  {
    num: 328,
    icon: `${CDN_URL}/offlinePay/goods/lingfu.png?v=1`,
    price: 328,
    name: '328灵符',
    id: 328
  },
  {
    num: 500,
    icon: `${CDN_URL}/offlinePay/goods/lingfu.png?v=1`,
    price: 500,
    name: '500灵符',
    id: 500
  },
  {
    num: 648,
    icon: `${CDN_URL}/offlinePay/goods/lingfu.png?v=1`,
    price: 648,
    name: '648灵符',
    id: 648
  },
  {
    num: 998,
    icon: `${CDN_URL}/offlinePay/goods/lingfu.png?v=1`,
    price: 998,
    name: '998灵符',
    id: 998
  },
  {
    num: 1998,
    icon: `${CDN_URL}/offlinePay/goods/lingfu.png?v=1`,
    price: 1998,
    name: '1998灵符',
    id: 1998
  },
]
